<template>
  <div
    v-if="users && ($login.can('users.view') || $login.can('users.view.channel'))"
    class="users-list"
  >
    <page-header header="Users">
      <router-link
        v-if="$login.can('users.create')"
        v-loading="loading"
        :to="{ name: 'users.create' }"
        class="ml-1 btn btn-primary "
      >
        Create user
      </router-link>
    </page-header>

    <div
      class="mt-3"
      v-if="users"
    >
    
      <div class="mb-3">
        <search
          :value="search"
          @input="updateSearchParam"
        />
      </div>
      <users-table :users="users" />
      <pagination
        :data="pagination"
        :disabled="loading"
        @change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import axios from '@/axios'
import {createHttpQuery, search} from '@/helpers'
import UsersTable from './Table'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'
import {successNotification} from '@/notifications'

const defaultParams = {
  page: 1,
  show_deleted: false,
}

export default {
  name: 'UserList',

  components: {
    UsersTable,
    Search,
    Pagination,
  },

  metaInfo () {
    return {
      title: 'Users',
    }
  },

  data () {
    const params = {
      ...defaultParams,
      ...this.$route.query,
    }

    return {
      params,
      users: null,
      pagination: null,
      loading: false,
      search: '',
    }
  },

  created () {
    this.getUsers()
  },

  methods: {
    async getUsers () {
      if (this.loading) {
        return
      }

      this.loading = true

      let data
      if (this.search.length > 0) {
        const params = createHttpQuery(this.params)
        data = await search('users', this.search, params)
      } else {
        const {page} = this.params
        const response = await axios.get('/users', {params: {page}})
        data = response.data
      }

      this.setData(data)
      this.loading = false
    },

    setData (users) {
      this.pagination = users.meta
      this.users = users.data
    },

    changePage (page = 1) {
      const {params} = this
      this.$router.push({query: {...params, page}})
    },

    updateSearchParam (search = '') {
      this.params.page = 1
      this.search = search
      this.getUsers()
    },

    confirmDelete (company) {
      this.$notify({
        group: 'confirm',
        type: 'error',
        title: 'Are you sure you want to delete ' + company.name + '?',
        data: {
          onConfirm: async () => {
            const {data} = await this.$http.delete('/users/' + company.id)
            if (!this.params.show_deleted) {
              this.users.splice(this.users.indexOf(company), 1)
            } else {
              this.users[this.users.indexOf(company)] = data
            }
            this.$notify(successNotification(`Deleted ${company.name}.`))
          },
        },
      })
    },

    async restore (company) {
      const {data} = await this.$http.patch('/users/' + company.id + '/restore')
      this.users[this.users.indexOf(company)] = data
      this.$notify(successNotification(`Restored ${company.name}.`))
    },
  },
}
</script>
